import TextArea from 'antd/es/input/TextArea'
import { requestChangeStatusTeamRegister } from 'app/api/event'
import { RegisterTeamActivityStatus } from 'app/api/event/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { notificationController } from 'app/controllers/notification-controller'
import { EventKeys } from 'app/react-query/query-key/event'
import { useAppSelector } from 'app/redux/hooks'
import { useRef, useState } from 'react'
import { useQueryClient } from 'react-query'

export const ModalRejectTeam = ({ id }: { id?: number }) => {
  const user = useAppSelector(state => state?.user)?.profile

  const refModal = useRef<IRefModal>({})

  const [form] = BaseForm.useForm<{ reason?: string }>()

  const query = useQueryClient()
  const [isLoadingReject, setIsLoadingReject] = useState(false)

  const onPressReject = async (
    id?: number,
    statusOther?: RegisterTeamActivityStatus,
    reason?: string,
  ) => {
    if (!id || !statusOther || !user?.member?.id) return
    try {
      setIsLoadingReject(true)

      const res = await requestChangeStatusTeamRegister({
        id,
        status: statusOther,
        reason,
        approvedById: +user?.member?.id,
      })
      if (res) {
        query.invalidateQueries({
          queryKey: EventKeys.allListActionNotJoinByTeam,
        })
        query.invalidateQueries({
          queryKey: EventKeys.allListActionRegisteredByTeam,
        })

        notificationController?.success({ message: 'Đã từ chối thành viên!' })
        refModal?.current?.hide?.()
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setIsLoadingReject(false)
    }
  }

  const handleSubmit = async (values?: { reason?: string }) => {
    if (!id) return
    await onPressReject(id, RegisterTeamActivityStatus.REJECTED, values?.reason)
  }

  return (
    <BaseModalComponent
      ref={refModal}
      titleModal="Từ chối đăng ký"
      buttonOpenModal={
        <BaseButton
          children="Từ chối"
          onClick={() => refModal.current?.open?.()}
          type="text"
        />
      }
      handleSubmit={form?.submit}
      isLoadingConfirm={isLoadingReject}
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseSpace size={8}>
            <BaseText children={'Lý do từ chối'} fontWeight="medium" />
            <BaseForm.Item
              hiddenLabel
              style={{ marginBottom: 0 }}
              name={'reason'}
              rules={[
                {
                  required: true,
                  message: 'Vui lòng nhập lý do từ chối',
                },
              ]}
            >
              <TextArea placeholder="Vui lòng nhập lý do từ chối" />
            </BaseForm.Item>
            <BaseText
              children={`Lưu ý: Bạn cần nhập lý do từ chối để đoàn viên biết tại sao họ không được phê duyệt`}
              colorText="statesOrangeColor"
              opacity="0.8"
            />
          </BaseSpace>
        </BaseForm>
      }
    />
  )
}
